import { trackById } from 'src/app/shared/utils/track-by.util';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { SensorAssignment } from '../../models/sensorAssignment.model';
import { ToastService } from '../../services/toast.service';
import { LoaderService } from '../../services/loader.service';
import { MatTableSortOptions } from 'src/app/models/sort.model';
import { DateFormatService } from 'src/app/services/dateFormat.service';
import { SensorAssignmentService } from 'src/app/services/sensorAssignment.service';

interface SensorAssignmentVm extends SensorAssignment {
  isTodayFlag: boolean;
}

@Component({
  standalone: false,
  selector: 'app-device-history',
  templateUrl: './device-history.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./device-history.component.scss'],
})
export class DeviceHistoryComponent implements OnInit, AfterViewInit {

  sensorsHistory: SensorAssignmentVm[];

  @Input() filterValue: string;
  sortBy: string = "id";
  orderBy: string = "asc";

  @Output()
  hideHistoryView = new EventEmitter<boolean>();

  constructor(private sensorAssignmentService: SensorAssignmentService,
    private toastService: ToastService,
    private loaderService: LoaderService,
    public dateFormatService: DateFormatService) {
  }

  ngOnInit(): void {
  }

  isToday(dateString) {
    const today = new Date();
    const date = new Date(dateString);

    return today.toDateString() === date.toDateString();
  }

  ngAfterViewInit() {
    if (this.filterValue) {
      this.load("createdDate", "desc");
    }
  }

  hideView() {
    this.hideHistoryView.emit(true);
  }

  sort(sortBy: string) {
    if (this.sortBy == sortBy) {
      this.orderBy = (this.orderBy == 'asc' ? 'desc' : 'asc');
    } else {
      this.sortBy = sortBy;
      this.orderBy = 'asc';
    }
    this.load(this.sortBy, this.orderBy);
  }

  sortDevicesByHistory(tableSortOptions: MatTableSortOptions) {
    this.orderBy = tableSortOptions.direction;
    this.sort(tableSortOptions.active);
  }

  load(orderBy = 'id', sort = 'asc') {
    this.loaderService.show();
    this.sensorAssignmentService.get(this.filterValue, orderBy, sort, 0, 10, '')
      .subscribe(sensors => {
        this.loaderService.hide();
        const today = new Date();
        this.sensorsHistory = (sensors?.data ?? []).map(device => ({
          ...device,
          isTodayFlag: today.toDateString() === new Date(device.createdDate as unknown as string).toDateString()
        }));
      }, error => {
        this.toastService.showError(error);
        this.loaderService.hide();
      });
  }

    public trackById = trackById;
}
